<template>
  <div>
    <top-menu-card
      mark="D"
      icon="mdi-file-chart"
      :color="color">
      <template #title>
        D. 詳細表の作成
      </template>
      <template #subtitle>
        現地調査結果入力によって作成した詳細表の修正追加等すべての記入を行い完成させる。
      </template>
      <template #actions>
        <v-spacer />
        <v-btn
          :color="color"
          outlined
          @click.prevent="onInputClicked">
          入力する
          <v-icon dense>mdi-arrow-right</v-icon>
        </v-btn>
      </template>
    </top-menu-card>
    <unsaved-session-confirm
      v-if="confirmDialog"
      v-model="confirmDialog"
      session-name="detail"
      route-name-new="detailEditStep1"
      route-name-continue="detailEditStep2"
      @cancel="confirmDialog=false" />
  </div>
</template>

<script>
import TopMenuCard from './TopMenuCard'
import UnsavedSessionConfirm from '../UnsavedSessionConfirm'

export default {
  name: 'TopDetailMenu',
  components: { UnsavedSessionConfirm, TopMenuCard },
  props: {
    color: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      confirmDialog: false,
    }
  },
  methods: {
    // 入力ボタン
    onInputClicked() {
      this.$router.push({ name: 'detailEditStep1' })
    },
  },
}
</script>
